/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPricingGroupDto
 */
export interface GetPricingGroupDto {
    /**
     * 
     * @type {string}
     * @memberof GetPricingGroupDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetPricingGroupDto
     */
    name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPricingGroupDto
     */
    active: boolean;
}

/**
 * Check if a given object implements the GetPricingGroupDto interface.
 */
export function instanceOfGetPricingGroupDto(value: object): value is GetPricingGroupDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    return true;
}

export function GetPricingGroupDtoFromJSON(json: any): GetPricingGroupDto {
    return GetPricingGroupDtoFromJSONTyped(json, false);
}

export function GetPricingGroupDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPricingGroupDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'active': json['active'],
    };
}

export function GetPricingGroupDtoToJSON(value?: GetPricingGroupDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'active': value['active'],
    };
}

